/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Chat_ReviewInputs */

const en_page_title_chat_review = /** @type {(inputs: Page_Title_Chat_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat review`)
};

const nl_page_title_chat_review = /** @type {(inputs: Page_Title_Chat_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chatbeoordeling`)
};

/**
* | output |
* | --- |
* | "Chat review" |
*
* @param {Page_Title_Chat_ReviewInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_chat_review = /** @type {((inputs?: Page_Title_Chat_ReviewInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Chat_ReviewInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_chat_review(inputs)
	return en_page_title_chat_review(inputs)
});